import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";

export const editCommentSchema = z.object({
	content: z.string().min(1).max(2000),
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
});

export type EditCommentPayload = z.infer<typeof editCommentSchema>;
